import { useState } from 'react';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import { LinkButton } from '../../../components/Toolkit/Button/LinkButton';

export interface SimpleShowMoreProps {
  visibleText: string;
  showMoreText?: string;
  hiddenText: string;
  className?: string;
  children?: ReactNode;
}

const SimpleShowMoreContainer = styled.div<{ showMore: boolean }>`
  display: grid;
  grid-template-rows: ${({ showMore }) =>
    showMore ? 'repeat(2, auto)' : 'auto'};
  grid-row-gap: ${({ theme }) => theme.spacing.S8};
`;

const P = styled.p`
  display: inline-block;
  ${({ theme }) => theme.fontSize.B14};
`;

function SimpleShowMore({
  visibleText,
  showMoreText = 'Show More',
  hiddenText,
  className,
  children,
}: SimpleShowMoreProps) {
  const [showMore, setShowMore] = useState<boolean>(false);
  return (
    <SimpleShowMoreContainer showMore={showMore} className={className}>
      <P>
        {visibleText}&nbsp;
        {!showMore && (
          <LinkButton
            ofType="SECONDARY"
            fontSize="B14"
            onClick={() => setShowMore(true)}
            underline
            inline
          >
            {showMoreText}
          </LinkButton>
        )}
      </P>
      {showMore && (
        <>
          <P>{hiddenText}</P>
          {children}
        </>
      )}
    </SimpleShowMoreContainer>
  );
}

export { SimpleShowMore };
